import { semanticThemeTokens, Sheet } from "@appretio/ui-kit";
import { Outlet, type RouteObject } from "react-router-dom";
import { BudgetPage } from "./pages/budgetPage/BudgetPage";

const ROOT = "pre-season" as const;

const PATH = {
  BUDGET: "budget",
  BUDGET_OVERVIEW: "budget-overview",
  BUDGET_SUMMARY: "budget-summary",
  MANAGE_CUBES: "manage-cubes",
  CONSUMER_ACTIVATION_PLAN: "consumer-activation-plan"
} as const;

const LABEL = {
  PRE_SEASON: "Pre-season",
  BUDGET: "Budget",
  BUDGET_SUMMARY: "Budget summary",
  MANAGE_CUBES: "Manage cubes",
  CONSUMER_ACTIVATION_PLAN: "Consumer Activation Plan"
} as const;

const BG = semanticThemeTokens.backgroundGradient[1];

export const preSeasonRoutes: RouteObject = {
  path: ROOT,
  handle: { label: LABEL.PRE_SEASON, background: BG },
  element: <Outlet />,
  children: [
    {
      path: PATH.BUDGET,
      handle: { label: LABEL.BUDGET, background: BG },
      element: <BudgetPage />,
      children: [
        {
          index: true,
          handle: { label: LABEL.BUDGET },
          element: <Sheet>{LABEL.BUDGET} page</Sheet>
        },
        {
          path: PATH.BUDGET_SUMMARY,
          handle: { label: LABEL.BUDGET_SUMMARY },
          element: <Sheet>{LABEL.BUDGET_SUMMARY} page</Sheet>
        },
        {
          path: PATH.MANAGE_CUBES,
          handle: { label: LABEL.MANAGE_CUBES },
          element: <Sheet>{LABEL.MANAGE_CUBES} page</Sheet>
        }
      ]
    },
    {
      path: PATH.CONSUMER_ACTIVATION_PLAN,
      handle: { label: LABEL.CONSUMER_ACTIVATION_PLAN },
      element: <Sheet>{LABEL.CONSUMER_ACTIVATION_PLAN} page</Sheet>
    }
  ]
};
